import {theme} from 'antd';
import React from 'react';
import OfferParentRow from './OfferParentRow';

interface OfferTableProps {
  rows: any;
  onReFulfillClick: (ClaimedOfferAdditionalData, string, boolean) => void;
}

// Hand-built expandable parent/child rows, not a flat data grid — kept as a
// plain <table> styled with antd tokens rather than forced into antd's
// columns/dataSource Table component.
const OfferTable = (props: OfferTableProps) => {
  const {token}: any = theme.useToken();

  return (
    <div
      style={{
        marginBottom: 24,
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        overflow: 'hidden',
        overflowX: 'auto',
      }}>
      <table aria-label="collapsible table" style={{width: '100%', borderCollapse: 'collapse'}}>
        <thead style={{background: token.colorPrimaryBg}}>
          <tr>
            <th style={{padding: 10, textAlign: 'left'}}>Confirmation&nbsp;#</th>
            <th style={{padding: 10, textAlign: 'left'}}>Date&nbsp;Ordered</th>
            <th style={{padding: 10, textAlign: 'left'}}>Type</th>
            <th style={{padding: 10, textAlign: 'left'}}>Redeemed&nbsp;By</th>
            <th style={{padding: 10, textAlign: 'left'}}>Status</th>
            <th style={{padding: 10, textAlign: 'left'}}>Order&nbsp;Type</th>
            <th style={{padding: 10, textAlign: 'left'}}>Merchant</th>
            <th style={{padding: 10, textAlign: 'left'}}>Cards</th>
            <th style={{padding: 10, textAlign: 'left'}}>Value</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {props.rows.map((row, index) => (
            <OfferParentRow
              key={row.id}
              onReFulfillClick={props.onReFulfillClick}
              backgroundColor={index % 2 !== 0 ? token.colorPrimaryBg : token.colorBgContainer}
              row={row}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default OfferTable;
